<template>
  <v-container class>
    <v-btn small fab color="indigo" router to="/activity">
      <v-icon medium color="white">add</v-icon>
    </v-btn>
    <v-btn left small fab color="white" router to="/dashboard">
      <v-icon medium color="red">close</v-icon>
    </v-btn>
    <h2 class="pa-1">COMPLETED CAPACITY BUILDING ACTIVITIES</h2>
    <v-tabs left color="white pa-1 ">
      <v-tabs-slider color="blue"></v-tabs-slider>
      <v-tab href="#tab-1">
        <v-tooltip top>
          <v-btn class="grey darken-2 white--text" medium @click="sortBy('title')" slot="activator">
            <v-icon small left>title</v-icon>
            <span>By title</span>
          </v-btn>
          <span>Sort by activity title</span>
        </v-tooltip>
      </v-tab>

      <v-tab href="#tab-2">
        <v-tooltip top>
          <v-btn
            class="grey darken-2 white--text"
            medium
            @click="sortBy('reference')"
            slot="activator"
          >
            <v-icon small left>business</v-icon>
            <span>By Organisation</span>
          </v-btn>
          <span>Sort by Organisation</span>
        </v-tooltip>
      </v-tab>

      <v-tab href="#tab-3">
        <v-tooltip top>
          <v-btn
            medium
            class="grey darken-2 white--text"
            @click="sortBy('startdate')"
            slot="activator"
          >
            <v-icon small left>date_range</v-icon>
            <span>By Date</span>
          </v-btn>
          <span text--white>Sort by activity date</span>
        </v-tooltip>
      </v-tab>
      <v-tab href="#tab-4">
        <v-text-field
          class="pa-1 white--text"
          v-model="search"
          label="Search a Training"
          prepend-icon="search"
        ></v-text-field>
      </v-tab>
      <v-tab-item v-for="i in 5" :key="i" :value="'tab-' + i"></v-tab-item>
    </v-tabs>
    <v-progress-linear v-if="progress" color="purple" :indeterminate="true"></v-progress-linear>
    <v-divider class="pa-1"></v-divider>
    <v-alert v-if="success" :value="true" :type="alerttype">
      {{alert}}
      <v-btn fab small @click="success=!success">
        <v-icon color="red darken-4" medium>close</v-icon>
      </v-btn>
    </v-alert>
    <v-expansion-panel v-model="panelIndex">
      <v-expansion-panel-content v-for="(project, i) in filteredTrainings" :key="project.docRef">
        <div slot="header" class="py-1">
          <h4>
            {{i+1}}. {{project.title }} by {{project.reference}} from
            {{project.startdate}} to {{project.enddate}}
          </h4>
        </div>
        <v-card flat>
          <h3 class="grey darken-2 pa-1 white--text">Basic Training Details</h3>
          <v-layout row wrap>
            <v-flex xs12 md4 class="teal lighten-5 pa-1">
              <h4 class="teal lighten-4 pa-1">Training Details</h4>
              <span v-for="type in project.type" :key="type[0]">{{type}} training for HRDs;</span>
              {{ project.level }}'s level
              <div>
                by
                <span class="teal--text">{{ project.reference }}</span>
              </div>
            </v-flex>
            <v-flex xs12 md4 class="teal lighten-5 pa-1">
              <h4 class="teal lighten-4 pa-1">Trainer Contacts details and affiliation</h4>
              <div class="pl-1">
                <h4>
                  Trainer(s):
                  <span class="teal--text">{{ project.tname }}</span>
                </h4>
              </div>
              <div class="pl-1">
                Affiliation:
                <span class="teal--text">{{project.taffiliation}}</span>
              </div>
              <div class="pl-1">
                Mobile No:
                <span class="teal--text">{{ project.tphone }}</span>
              </div>
              <div class="pl-1">
                Email:
                <span class="teal--text">{{ project.temail }}</span>
              </div>
            </v-flex>
            <v-flex xs12 md2 class="teal lighten-5 pa-1">
              <h4 class="teal lighten-4 pa-1">Mobilisation</h4>
              <div class="pl-1">
                Participants mobilised by:
                <span class="teal--text">{{ project.mobiliser }}</span>
              </div>
            </v-flex>
            <v-flex xs12 md2 class="teal lighten-5 pa-1">
              <h4 class="teal lighten-4 pa-1">ACTIONS</h4>
              <v-btn fab small v-on:click="editRecord(project.docRef)">
                <v-icon color="indigo darken-3">edit</v-icon>
              </v-btn>
              <v-btn disabled v-if="admin" fab small v-on:click="deleteRecord(project.docRef)">
                <v-icon medium color="red lighten-2">delete_forever</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <h3 class="teal lighten-4 pa-1">
            <span text--white>Participants List</span>
            <v-btn
              v-if="!panel"
              small
              fab
              @click="participantsView(project.docRef)"
              slot="activator"
            >
              <v-icon medium>expand_more</v-icon>
              <span>Participants List</span>
            </v-btn>
          </h3>
        </v-card>
        <v-card flat v-for="(person,i) in participantsList" :key="person.id">
          <v-layout v-if="panel" row wrap>
            <v-flex xs12 md4 class="teal lighten-5 pa-1">
              <div class="pa-1">
                <h4 class="teal--text">{{i+1}}. {{person.p_name }}</h4>
                <div>Mobile No: {{person.p_phone}}</div>
                <div>Email: {{person.p_email }}</div>
              </div>
            </v-flex>

            <v-flex xs12 md4 class="teal lighten-5 pa-1">
              <div class="pa-1">
                <h4 class="teal--text">{{ person.p_org }}</h4>
                <div>{{person.area}} , {{person.county}}</div>
                <div v-for="(area,i) in person.theme" :key="area[0]">Theme {{i+1}}. {{area}}</div>
              </div>
            </v-flex>
            <v-flex xs12 md2 class="teal lighten-5 pa-1">
              <div class="pa-1">
                <h4 class="teal--text">Training Level</h4>
                <div class="pl-1">{{person.level}}</div>
              </div>
            </v-flex>
            <v-flex xs12 md2 class="teal lighten-5 pa-1">
              <div class="pa-1">
                <h4 class="teal--text">ACTIONS</h4>
                <div>
                  <v-btn small fab flat class="white">
                    <v-icon color="indigo">edit</v-icon>
                  </v-btn>
                  <v-btn disabled small fab flat class="white">
                    <v-icon medium color="red lighten-2">delete_forever</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-divider class="teal lighten-3"></v-divider>
        </v-card>
        <v-divider class="grey darken-2 pa-1 white--text"></v-divider>
      </v-expansion-panel-content>
      <v-divider class="grey darken-2 pa-1 white--text"></v-divider>
    </v-expansion-panel>
  </v-container>
</template>

<script>
import { db, auth, functions } from "@/fb";

export default {
  data() {
    return {
      categories: [],
      projects: [],
      participants: [],
      name: "",
      panelIndex: -9,
      reference: "",
      detail: true,
      complete: true,
      trainingRef: "",
      participantRef: "",
      panel: false,
      admin: false,
      //Data for Search
      search: "",
      typeof: "",
      select: "",
      progress: true,
      alerttype: "green",
      success: false,
      alert: ""
    };
  },
  computed: {
    participantsList() {
      return this.participants.filter(participant => {
        return participant.refno === this.trainingRef;
      });
    },
    filteredTrainings() {
      //  if (search != '') {
      return this.projects.filter(item => {
        return item.title
          .toLowerCase()
          .trim()
          .match(this.search.toLowerCase().trim());
      });
      /*  } else {
          return this.projects.filter((item) => {
            return item.type.toLowerCase().trim().match(this.typeof.toLowerCase().trim())
          })
        }  */
    }
  },
  watch: {
    panelIndex: function() {
      this.panel = false;
    }
  },
  methods: {
    participantsView(input) {
      this.trainingRef = input;
      this.panel = true;
    },
    sortBy(prop) {
      this.projects.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
    },
    selectedCat(input) {
      this.typeof = input;
    },
    editRecord(ref) {
      this.$router.push({ name: "activity", params: { ref } });
    },
    deleteRecord(ref) {
      db.collection("trainings")
        .doc(ref)
        .delete()
        .then(function() {
          alerttype = "green";
          this.alert = "The record has been successfully Deleted";
        })
        .catch(function(error) {
          alerttype = "error";
          this.alert = "Error: " + error;
        });
    }
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    this.progress = false;
    auth.onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult().then(idTokenResult => {
          if (idTokenResult.claims.admin == true) {
            this.admin = true;
          } else {
            this.admin = false;
          }
        });
      }
    });

    db.collection("trainings")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.reference = doc.data().reference;
          this.trainingref = doc.data().docRef;
          this.projects.push(doc.data());
        });
      });

    db.collection("participants")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.participantRef = doc.data().refno;
          this.participants.push(doc.data());
        });
      });

    db.collection("t_categories")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.categories.push(doc.data());
        });
      });
  }
};
</script>
